var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgBed(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 25 18' }, props),
        React.createElement("path", { d: 'M21 6.536a3.5 3.5 0 013.495 3.308l.005.192v6.616a.5.5 0 01-.992.09l-.008-.09v-6.616a2.5 2.5 0 00-2.336-2.495L21 7.536H4a2.5 2.5 0 00-2.495 2.336l-.005.164v6.616a.5.5 0 01-.992.09l-.008-.09v-6.616a3.5 3.5 0 013.308-3.495L4 6.536h17z' }),
        React.createElement("path", { d: 'M19 .5a3.5 3.5 0 013.495 3.308L22.5 4v3a.5.5 0 01-.992.09L21.5 7V4a2.5 2.5 0 00-2.336-2.495L19 1.5H6a2.5 2.5 0 00-2.495 2.336L3.5 4v3a.5.5 0 01-.992.09L2.5 7V4A3.5 3.5 0 015.808.505L6 .5h13z' }),
        React.createElement("path", { d: 'M8 3.5A3.5 3.5 0 0111.5 7a.5.5 0 11-1 0 2.5 2.5 0 00-5 0 .5.5 0 01-1 0A3.5 3.5 0 018 3.5zm9 0A3.5 3.5 0 0120.5 7a.5.5 0 11-1 0 2.5 2.5 0 10-5 0 .5.5 0 11-1 0A3.5 3.5 0 0117 3.5zm6.5 8.9a.5.5 0 01.09.992l-.09.008H1a.5.5 0 01-.09-.992L1 12.4h22.5z' })));
}
export default SvgBed;
//# sourceMappingURL=Bed.js.map